
import { defineComponent } from 'vue'
import View from '@/components/View.vue'

export default defineComponent({
  components: { View },
})
